import uniq from '@tinkoff/utils/array/uniq'
import { URL_PARSE_OPTIONS } from 'application/configuration/constants'
import { FilterDeclaration, FilterValues } from 'features/filter/types'
import { parseUrl } from 'query-string'

import { objectHasProperty } from '../../../lib/typescript-helpers'

export const filterDeclarationToFilterValues = (declaration: FilterDeclaration): FilterValues => {
  const values = [...declaration.sections].reduce((values, section) => {
    return {
      ...values,
      [section.key]: []
    }
  }, {})
  return {
    ...values
  }
}

/*Получение какие категории нужно скрыть, при фильтрации*/
export const getDisabledValues = (filterValues: FilterValues, declaration: FilterDeclaration): FilterValues => {
  let listDisabledItems = <any>[]
  const disabledValues = declaration.sections.reduce((values, section) => {
    const exclusivelyEnabledGroups = section.groups.filter((group) => {
      if (group.dependence) {
        return (
          filterValues[group.dependence?.key] && filterValues[group.dependence.key].includes(group.dependence.value)
        )
      }
      return false
    })

    const disabledGroups = exclusivelyEnabledGroups.length
      ? section.groups.filter((g) => !exclusivelyEnabledGroups.includes(g))
      : []
    disabledGroups.map((group) => {
      group.fields.map((field) => {
        if (field.value) {
          let index = filterValues[section.key].indexOf(field.value)
          if (index >= 0) {
            filterValues[section.key].splice(index, 1)
          }
        }
      })
    })

    let disabledValues = <any>[]
    if (disabledGroups.length > 0) {
      disabledGroups.map((disabledItem) => {
        disabledItem.fields.map((disabledField) => {
          listDisabledItems.push(disabledField.value)
        })
      })
      // @ts-ignore
      disabledValues = disabledGroups.flatMap((group) => group.fields.map((field) => field.value))
    } else if (section.key === 'generation') {
      section.groups.map((sectionGroup) => {
        if (listDisabledItems.includes(sectionGroup.dependence?.value)) {
          sectionGroup.fields.map((field) => {
            disabledValues.push(field.value)
          })
        }
      })

      // if (disabledGroups.length === 0 && exclusivelyEnabledGroups.length === 0) {
      section.groups.map((sectionGroup) => {
        if (sectionGroup.dependence?.key && filterValues[sectionGroup.dependence.key].length) {
          sectionGroup.fields.map((field) => {
            disabledValues.push(field.value)
          })
        }
      })
      // }
    }

    return {
      ...values,
      [section.key]: disabledValues
    }
  }, {})

  return disabledValues
}

export const getFilterValuesFromUrl = (declaration: FilterDeclaration) => {
  const queryValues = parseUrl(window.location.href, URL_PARSE_OPTIONS).query

  const filterValues: FilterValues = {}

  for (const section of declaration.sections) {
    const queryValue = queryValues[section.key]
    if (!queryValue) continue

    const filterValue = (() => {
      const isNumeric = section.type === 'range'
      if (queryValue instanceof Array) {
        return isNumeric ? queryValue.map((v) => Math.round(parseFloat(v) * 10) / 10) : queryValue
      } else {
        return isNumeric ? [parseFloat(queryValue)] : [queryValue]
      }
    })()

    filterValues[section.key] = filterValue
  }

  return filterValues
}

export const mergeFilterValues = (
  filterValues: FilterValues,
  newValues: FilterValues,
  filterDeclaration: FilterDeclaration
) => {
  if (filterValues === null) return newValues || {}
  if (newValues === null) return filterValues || {}

  const newKeys = uniq([...Object.keys(filterValues), ...Object.keys(newValues)])

  const result: FilterValues = {}

  for (const key of newKeys) {
    const knownSectionType = filterDeclaration?.sections.find((section) => section.key === key)?.type

    if (knownSectionType === 'range') {
      const oldValue = filterValues[key] || []
      const newValue = newValues[key]
      result[key] = newValue
        ? [Math.round(Number(newValue[0]) * 100) / 100, Math.round(Number(newValue[1]) * 100) / 100]
        : oldValue
    } else {
      const oldValue = filterValues[key] || []
      const newValue = newValues[key] || []

      const finalValue = uniq([...oldValue, ...newValue])
      result[key] = finalValue
    }
  }

  return result
}

export const removeFilterValues = (
  filterValues: FilterValues | null,
  valuesToRemove: FilterValues | null,
  declaration: FilterDeclaration
) => {
  if (filterValues === null) return {}
  if (valuesToRemove === null) return filterValues
  const result = { ...filterValues }

  for (const key in valuesToRemove) {
    if (filterValues[key]) {
      if (valuesToRemove[key][0] === 'min') {
        const section = declaration.sections.find((item) => item.key === key)
        if (section && objectHasProperty(section.groups[0].fields[0], 'min')) {
          result[key][0] = section.groups[0].fields[0].min
        }
      } else if (valuesToRemove[key][0] === 'max') {
        const section = declaration.sections.find((item) => item.key === key)
        if (section && objectHasProperty(section.groups[0].fields[0], 'max')) {
          result[key][1] = section.groups[0].fields[0].max
        }
      } else {
        result[key] = filterValues[key].filter((value) => {
          return !valuesToRemove[key].includes(value)
        })
      }
    }
  }

  return result
}

export const replaceFilterValues = (filterValues: FilterValues | null, valuesToReplace: FilterValues) => {
  if (filterValues === null) return {}
  const result = { ...filterValues }
  for (const key in valuesToReplace) {
    if (result[key]) {
      result[key] = valuesToReplace[key]
    }
  }
  return result
}

export const resetAndApplyFilterValues = (filterValues: FilterValues, newValues: FilterValues) => {
  const result = { ...filterValues }
  for (const key in result) {
    result[key] = newValues[key] || []
  }
}
